import React, { memo } from 'react';
import Head from 'next/head';

import PrivacyPolicyContainer from 'containers/PrivacyPolicyContainer';

import { quizListUrl } from 'utils/api/requestUrls';

const PrivacyPolicy = (props: any) => {
  return <>
    <Head>
      <title>Политика конфиденциальности персональных данных компании Old mouse в Минске</title>
      <meta name="description" content={"Политика конфиденциальности персональных данных компании Old mouse в Минске!"} />
    </Head>

    <PrivacyPolicyContainer {...props} />
  </>
};

export const getServerSideProps = async (context) => {
  const { req, res } = context;

  const questListResponse = await fetch(quizListUrl(null, null));
  const questListFirstData = await questListResponse.json();

  if (req.headers.host.match(/^www/) !== null) {
    res.writeHead(301, {
      location: "https://" + req.headers.host.replace(/^www./, "") + req.url,
    });
    res.end();
  };

  return { props: { questListFirstData: questListFirstData?.content, } };
};

export default memo(PrivacyPolicy);
